import classNames from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { closePopup } from "../../redux/actions/modal";

export default function ({ children }) {
  const dispatch = useDispatch();
  const [ref, setRef] = useState(null);
  const [initialClass, setInitialClass] = useState(false);
  const setObjRef = useCallback(setRef, []);

  const clickHandler = (event) => {
    if (ref && event.target === ref) {
      dispatch(closePopup());
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setInitialClass(true);
    });

    return () => setInitialClass(false);
  }, []);

  return (
    <div
      className={classNames("back-wrapper", { initialized: !!initialClass })}
      ref={setObjRef}
      // onClick={clickHandler}
    >
      {children}
    </div>
  );
}
